import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row" }
const _hoisted_2 = {
  key: 0,
  class: "p-dropdown-car-value"
}
const _hoisted_3 = { class: "p-dropdown-car-option" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "p-float-label" }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "p-float-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputText = _resolveComponent("InputText")
  const _component_AutoComplete = _resolveComponent("AutoComplete")
  const _component_Card = _resolveComponent("Card")

  return (_ctx.currentFilter)
    ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
        header: _withCtx(() => [
          _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
            start: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.filter.placeholderName), 1)
            ]),
            _: 1
          })
        ]),
        content: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_Dropdown, {
              id: "valueCd",
              class: "kn-material-input p-mr-2",
              style: _ctx.kpiSchedulerFilterDetailCardDescriptor.input.style,
              modelValue: _ctx.currentFilter.type,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentFilter.type = $event)),
              options: _ctx.placeholderType,
              onChange: _ctx.resetValue
            }, {
              value: _withCtx((slotProps) => [
                (slotProps.value)
                  ? (_openBlock(), _createBlock("div", _hoisted_2, [
                      _createVNode("span", null, _toDisplayString(slotProps.value['valueCd']), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              option: _withCtx((slotProps) => [
                _createVNode("div", _hoisted_3, [
                  _createVNode("span", null, _toDisplayString(slotProps.option.valueCd), 1)
                ])
              ]),
              _: 1
            }, 8, ["style", "modelValue", "options", "onChange"]),
            (_ctx.currentFilter.type.valueCd === 'FIXED_VALUE')
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _createVNode("span", _hoisted_5, [
                    _createVNode(_component_InputText, {
                      class: ["kn-material-input", {
                                'p-invalid': _ctx.currentFilter.value === ''
                            }],
                      style: _ctx.kpiSchedulerFilterDetailCardDescriptor.input.style,
                      modelValue: _ctx.currentFilter.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentFilter.value = $event)),
                      modelModifiers: { trim: true },
                      onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched')))
                    }, null, 8, ["class", "style", "modelValue"]),
                    _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('common.value')) + " * ", 1)
                  ])
                ]))
              : (_ctx.currentFilter.type.valueCd === 'TEMPORAL_FUNCTIONS')
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _createVNode("span", _hoisted_8, [
                      _createVNode(_component_Dropdown, {
                        id: "valueCd",
                        class: "kn-material-input p-mr-2",
                        style: _ctx.kpiSchedulerFilterDetailCardDescriptor.input.style,
                        optionLabel: "valueCd",
                        optionValue: "valueCd",
                        modelValue: _ctx.currentFilter.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.currentFilter.value = $event)),
                        options: _ctx.temporalType,
                        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('touched')))
                      }, null, 8, ["style", "modelValue", "options"])
                    ])
                  ]))
                : (_ctx.currentFilter.type.valueCd === 'LOV')
                  ? (_openBlock(), _createBlock("div", _hoisted_9, [
                      _createVNode("span", _hoisted_10, [
                        _createVNode(_component_AutoComplete, {
                          class: "p-mr-2",
                          style: _ctx.kpiSchedulerFilterDetailCardDescriptor.input.style,
                          modelValue: _ctx.currentFilter.value,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.currentFilter.value = $event)),
                          suggestions: _ctx.filteredLovs,
                          field: "name",
                          dropdown: true,
                          forceSelection: true,
                          onComplete: _cache[7] || (_cache[7] = ($event: any) => (_ctx.searchCategories($event))),
                          onItemSelect: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setLovValue($event.value, _ctx.filter)))
                        }, null, 8, ["style", "modelValue", "suggestions"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}